/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'personal-contact',
  template: require('./personal-contact.component.html')
})
export class PersonalContactComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    const steps = this.flowManager.getStepArrays('personal-contact');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;
    this.cipActive = this.flowManager.settings['cip_pct'] && this.flowManager.settings['cip_pct'].active === true;
  }

  btnClick(e) {
    if (e.action === 'next' &&
      this.cipActive === true &&
      this.flowManager.isAuthed !== true &&
      this.flowManager.completedCipForm !== true) {

      if (this.flowManager.isSubmittingDAPI !== true) {
        this.flowManager.isSubmittingDAPI = true;
        this.form.buttons.inputs.next.classes += ' spinner';
        const payload = this.appActions.getState();
        this.appProxy.getKBA(payload, resp => {
          if (resp.status === 200) {
            this.form.buttons.inputs.next.path = '/cip';
          } else {
            this.flowManager.completedCipForm = true;
          }
          this.flowManager.isSubmittingDAPI = false;
          this.handleClick(e.action);
        });
      }

    } else {
      this.handleClick(e.action);
    }
  }
}
